module.exports = __webpack_public_path__ + "static/img/u27.cc7cc3cc.webp";